import Vertical from "./verticalMenu"

export default function Core ({ navigation, context }) {
    return (
        <> 
            <section id="core" className="overflow-hidden bg-gray py-12">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                        <div className="col-span-1 md:-ml-4 lg:-ml-0">           
                            <div className="lg:max-w-3xl">  
                                {context.map((value, id)  => (
                                    <>  
                                        <div className='py-6'>
                                            {value.title}
                                            <ul role="list" className="mt-6 space-y-4">  
                                                {value.core.map((val, id) => (
                                                    <>
                                                        <li className='text-lg leading-6 text-gray-600'>   
                                                            {val.subtitle}
                                                            {val.text}
                                                        </li>
                                                    </>
                                                ))}
                                        </ul>
                                        </div>
                                    </>
                                ))}                                
                            </div>
                        </div>
                        <div className="col-span-1 md:-ml-4 lg:-ml-0 relative hidden lg:block">           
                            <div className="lg:max-w-lg">
                                <Vertical navigation={navigation} />
                            </div>
                        </div> 
                    </div>
                </div>
            </section>
        </>
    )
}